// web/src/theme/applyTheme/_storage.ts —— 内部：写变量 / 图表色同步 / 旧主题键迁移
// 拆自 web/src/theme/applyTheme.ts 的同名分区（内容原样搬运）；由 web/src/theme/applyTheme.ts 以 export * 聚合，导出面对调用方不变。

import { CHART_COLORS, CHART_PALETTE } from '../../utils/chartTheme';
import { syncPaletteColors } from '../palette';
import { BORDER_LEVELS, DEFAULT_BORDER_LEVEL, getBorderLevel, type BorderLevelDef, type BorderToneSpec } from '../borders';
import {
  DEFAULT_DENSITY,
  DEFAULT_LANDING,
  DEFAULT_MENU_EXPAND,
  DEFAULT_MOTION,
  DEFAULT_RADIUS,
  DEFAULT_TIME_FMT,
  DEFAULT_WIDTH,
  MOTION_MEDIA_QUERY,
  getDensityLevel,
  getLandingLevel,
  getMenuExpandLevel,
  getMotionLevel,
  getRadiusLevel,
  getTimeFmtLevel,
  getWidthLevel,
  resolveRadius,
  type DensityLevelDef,
  type RadiusLevelDef,
  type WidthLevelDef,
} from '../uiPrefs';
import { DEFAULT_THEME_KEY, getTheme, type ThemeDef } from '../themes';
export function writeVars(el: HTMLElement, vars: Record<string, string>, appliedSet: Set<string>) {
  appliedSet.forEach((prop) => el.style.removeProperty(prop));
  appliedSet.clear();
  Object.entries(vars).forEach(([prop, value]) => {
    el.style.setProperty(prop, value);
    appliedSet.add(prop);
  });
}

/**
 * 同步 ECharts 色板：canvas 不解析 CSS 变量，图表色只能字面量下发。
 * 就地改写 `chartTheme.ts` 的对象/数组，页面无需改动 import 方式；
 * 已渲染的图表保持旧色，页面重新挂载（切换路由/刷新）后即跟随新主题。
 *
 * 分类色板的后 3 档由**本主题派生**（AI 深档 / AI 浅档 / 中性），不再写死固定色：
 * 固定尾色会让主题的 AI 键与尾色撞成同一颜色（如暖色 AI 主题里出现两条同色系列）。
 */
export function syncChartTheme(t: ThemeDef) {
  const colors = CHART_COLORS as unknown as Record<string, string>;
  colors.primary = t.primary;
  colors.purple = t.ai;
  const palette = CHART_PALETTE as unknown as string[];
  palette.splice(0, palette.length, t.primary, colors.success, colors.warning, colors.danger, t.ai, t.aiLight, t.aiDeep, colors.neutral);
  // 遗留字面色板（`theme/palette.ts`）同批同步：它是多个页面的图标底/图表系列来源
  syncPaletteColors(t);
}

/**
 * 已下线主题键 → 最近的在库主题（按 OKLab 感知距离取最近邻，避免老用户静默掉回默认主题）：
 * `navy` 与 `night-voyage` 主色 ΔE 5.0（同为低饱和深蓝，壳层深浅随之变化是已知差异）；
 * `celadon` 与 `sand` 主色 ΔE 6.3 / AI 色 ΔE 6.0（观感基本延续）。
 */
export const LEGACY_THEME_KEYS: Record<string, string> = { navy: 'night-voyage', celadon: 'sand' };

